import * as storage from "./storage";
import { Drawing } from "../lib/drawing";
import { serialize, SerializedDrawing } from "../lib/drawing/serialize";
import { abstract, cheers, watch } from "./drawing-samples";

const drawingsKey = "drawings";

export async function read(): Promise<Drawing[]> {
  let drawings = await storage.read<SerializedDrawing[]>(drawingsKey);
  if (drawings) return drawings.map((drawing) => new Drawing(drawing));

  const defaults = [abstract, cheers, watch];
  storage.write(
    drawingsKey,
    defaults.map((drawing) => serialize(drawing))
  );
  return defaults;
}

export function write(drawings: Drawing[]): void {
  storage.write(
    drawingsKey,
    drawings.map((drawing) => serialize(drawing))
  );
}
